var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"wrapper",class:['wrapper', _vm.enableSlider ? '' : 'wrapper--hidden'],style:({
      opacity: _vm.opHand,
      transform: ("translateY(" + ((120 * (_vm.delta))) + "%)"),
    }),attrs:{"data-hero-image":""}}),_vm._v(" "),_c('Hero'),_vm._v(" "),_c('Arrows',{class:[_vm.isSafari() ? _vm.$style.fixSafari : false],style:({
      display: _vm.op === 0 ? 'none' : 'inline-block',
      opacity: _vm.op,
      transform: ("translateY(" + ((100 * (_vm.delta))) + "%)")
    })})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4350d56e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CanvasHero.vue
// module id = null
// module chunks = 